export enum Permissions {
  // All permissions
  ALL = 'ALL',

  // Address permissions
  ADDRESS = 'ADDRESS',
  ADDRESS_CREATE = 'ADDRESS_CREATE',
  ADDRESS_READ = 'ADDRESS_READ',
  ADDRESS_UPDATE = 'ADDRESS_UPDATE',
  ADDRESS_DELETE = 'ADDRESS_DELETE',

  // Alarm central permissions
  ALARM_CENTRAL = 'ALARM_CENTRAL',
  ALARM_CENTRAL_CREATE = 'ALARM_CENTRAL_CREATE',
  ALARM_CENTRAL_READ = 'ALARM_CENTRAL_READ',
  ALARM_CENTRAL_UPDATE = 'ALARM_CENTRAL_UPDATE',
  ALARM_CENTRAL_DELETE = 'ALARM_CENTRAL_DELETE',

  // Contact ID event permissions
  CONTACT_ID_EVENT = 'CONTACT_ID_EVENT',
  CONTACT_ID_EVENT_CREATE = 'CONTACT_ID_EVENT_CREATE',
  CONTACT_ID_EVENT_READ = 'CONTACT_ID_EVENT_READ',
  CONTACT_ID_EVENT_UPDATE = 'CONTACT_ID_EVENT_UPDATE',
  CONTACT_ID_EVENT_DELETE = 'CONTACT_ID_EVENT_DELETE',

  // Responsible permissions
  RESPONSIBLE = 'RESPONSIBLE',
  RESPONSIBLE_CREATE = 'RESPONSIBLE_CREATE',
  RESPONSIBLE_READ = 'RESPONSIBLE_READ',
  RESPONSIBLE_UPDATE = 'RESPONSIBLE_UPDATE',
  RESPONSIBLE_DELETE = 'RESPONSIBLE_DELETE',

  // Student permissions
  STUDENT = 'STUDENT',
  STUDENT_CREATE = 'STUDENT_CREATE',
  STUDENT_READ = 'STUDENT_READ',
  STUDENT_UPDATE = 'STUDENT_UPDATE',
  STUDENT_DELETE = 'STUDENT_DELETE',

  // User permissions
  USER = 'USER',
  USER_CREATE = 'USER_CREATE',
  USER_READ = 'USER_READ',
  USER_UPDATE = 'USER_UPDATE',
  USER_DELETE = 'USER_DELETE',

  // EVENTS permissions
  EVENTS = 'EVENTS',

  // Face Detect Event permissions
  FACE_DETECT_EVENT = 'FACE_DETECT_EVENT',
  FACE_DETECT_EVENT_CREATE = 'FACE_DETECT_EVENT_CREATE',
  FACE_DETECT_EVENT_READ = 'FACE_DETECT_EVENT_READ',
  FACE_DETECT_EVENT_UPDATE = 'FACE_DETECT_EVENT_UPDATE',
  FACE_DETECT_EVENT_DELETE = 'FACE_DETECT_EVENT_DELETE',

  // Face Recognition Event permissions
  FACE_RECOGNITION_EVENT = 'FACE_RECOGNITION_EVENT',
  FACE_RECOGNITION_EVENT_CREATE = 'FACE_RECOGNITION_EVENT_CREATE',
  FACE_RECOGNITION_EVENT_READ = 'FACE_RECOGNITION_EVENT_READ',
  FACE_RECOGNITION_EVENT_UPDATE = 'FACE_RECOGNITION_EVENT_UPDATE',
  FACE_RECOGNITION_EVENT_DELETE = 'FACE_RECOGNITION_EVENT_DELETE',

  // Ivs Event permissions
  IVS_EVENT = 'IVS_EVENT',
  IVS_EVENT_CREATE = 'IVS_EVENT_CREATE',
  IVS_EVENT_READ = 'IVS_EVENT_READ',
  IVS_EVENT_UPDATE = 'IVS_EVENT_UPDATE',
  IVS_EVENT_DELETE = 'IVS_EVENT_DELETE',

  // Lpr Event permissions
  LPR_EVENT = 'LPR_EVENT',
  LPR_EVENT_CREATE = 'LPR_EVENT_CREATE',
  LPR_EVENT_READ = 'LPR_EVENT_READ',
  LPR_EVENT_UPDATE = 'LPR_EVENT_UPDATE',
  LPR_EVENT_DELETE = 'LPR_EVENT_DELETE',

  // Responsible Recognition Event permissions
  RESPONSIBLE_RECOGNITION_EVENT = 'RESPONSIBLE_RECOGNITION_EVENT',
  RESPONSIBLE_RECOGNITION_EVENT_CREATE = 'RESPONSIBLE_RECOGNITION_EVENT_CREATE',
  RESPONSIBLE_RECOGNITION_EVENT_READ = 'RESPONSIBLE_RECOGNITION_EVENT_READ',
  RESPONSIBLE_RECOGNITION_EVENT_UPDATE = 'RESPONSIBLE_RECOGNITION_EVENT_UPDATE',
  RESPONSIBLE_RECOGNITION_EVENT_DELETE = 'RESPONSIBLE_RECOGNITION_EVENT_DELETE',

  // Student Recognition Event permissions
  STUDENT_RECOGNITION_EVENT = 'STUDENT_RECOGNITION_EVENT',
  STUDENT_RECOGNITION_EVENT_CREATE = 'STUDENT_RECOGNITION_EVENT_CREATE',
  STUDENT_RECOGNITION_EVENT_READ = 'STUDENT_RECOGNITION_EVENT_READ',
  STUDENT_RECOGNITION_EVENT_UPDATE = 'STUDENT_RECOGNITION_EVENT_UPDATE',
  STUDENT_RECOGNITION_EVENT_DELETE = 'STUDENT_RECOGNITION_EVENT_DELETE',

  // Temperature Detect Event permissions
  TEMPERATURE_DETECT_EVENT = 'TEMPERATURE_DETECT_EVENT',
  TEMPERATURE_DETECT_EVENT_CREATE = 'TEMPERATURE_DETECT_EVENT_CREATE',
  TEMPERATURE_DETECT_EVENT_READ = 'TEMPERATURE_DETECT_EVENT_READ',
  TEMPERATURE_DETECT_EVENT_UPDATE = 'TEMPERATURE_DETECT_EVENT_UPDATE',
  TEMPERATURE_DETECT_EVENT_DELETE = 'TEMPERATURE_DETECT_EVENT_DELETE',

  // DEVICES permissions
  DEVICES = 'DEVICES',

  // Face Recognition permissions
  FACE_RECOGNITION_DEVICE = 'FACE_RECOGNITION_DEVICE',
  FACE_RECOGNITION_DEVICE_CREATE = 'FACE_RECOGNITION_DEVICE_CREATE',
  FACE_RECOGNITION_DEVICE_READ = 'FACE_RECOGNITION_DEVICE_READ',
  FACE_RECOGNITION_DEVICE_UPDATE = 'FACE_RECOGNITION_DEVICE_UPDATE',
  FACE_RECOGNITION_DEVICE_DELETE = 'FACE_RECOGNITION_DEVICE_DELETE',

  // Facial Control permissions
  FACIAL_CONTROL_DEVICE = 'FACIAL_CONTROL_DEVICE',
  FACIAL_CONTROL_DEVICE_CREATE = 'FACIAL_CONTROL_DEVICE_CREATE',
  FACIAL_CONTROL_DEVICE_READ = 'FACIAL_CONTROL_DEVICE_READ',
  FACIAL_CONTROL_DEVICE_UPDATE = 'FACIAL_CONTROL_DEVICE_UPDATE',
  FACIAL_CONTROL_DEVICE_DELETE = 'FACIAL_CONTROL_DEVICE_DELETE',

  // IVS permissions
  IVS_DEVICE = 'IVS_DEVICE',
  IVS_DEVICE_CREATE = 'IVS_DEVICE_CREATE',
  IVS_DEVICE_READ = 'IVS_DEVICE_READ',
  IVS_DEVICE_UPDATE = 'IVS_DEVICE_UPDATE',
  IVS_DEVICE_DELETE = 'IVS_DEVICE_DELETE',

  // LPR permissions
  LPR_DEVICE = 'LPR_DEVICE',
  LPR_DEVICE_CREATE = 'LPR_DEVICE_CREATE',
  LPR_DEVICE_READ = 'LPR_DEVICE_READ',
  LPR_DEVICE_UPDATE = 'LPR_DEVICE_UPDATE',
  LPR_DEVICE_DELETE = 'LPR_DEVICE_DELETE',

  // Temperature detector permissions
  TEMPERATURE_DETECTOR_DEVICE = 'TEMPERATURE_DETECTOR_DEVICE',
  TEMPERATURE_DETECTOR_DEVICE_CREATE = 'TEMPERATURE_DETECTOR_DEVICE_CREATE',
  TEMPERATURE_DETECTOR_DEVICE_READ = 'TEMPERATURE_DETECTOR_DEVICE_READ',
  TEMPERATURE_DETECTOR_DEVICE_UPDATE = 'TEMPERATURE_DETECTOR_DEVICE_UPDATE',
  TEMPERATURE_DETECTOR_DEVICE_DELETE = 'TEMPERATURE_DETECTOR_DEVICE_DELETE',

  // Tuya permissions
  TUYA_DEVICE = 'TUYA_DEVICE',
  TUYA_DEVICE_CREATE = 'TUYA_DEVICE_CREATE',
  TUYA_DEVICE_READ = 'TUYA_DEVICE_READ',
  TUYA_DEVICE_UPDATE = 'TUYA_DEVICE_UPDATE',
  TUYA_DEVICE_DELETE = 'TUYA_DEVICE_DELETE',

  // INTEGRATIONS permissions
  INTEGRATIONS = 'INTEGRATIONS',

  // Cigam permissions
  CIGAM_INTEGRATION = 'CIGAM_INTEGRATION',
  CIGAM_INTEGRATION_CREATE = 'CIGAM_INTEGRATION_CREATE',
  CIGAM_INTEGRATION_READ = 'CIGAM_INTEGRATION_READ',
  CIGAM_INTEGRATION_UPDATE = 'CIGAM_INTEGRATION_UPDATE',
  CIGAM_INTEGRATION_DELETE = 'CIGAM_INTEGRATION_DELETE',

  // Defense permissions
  DEFENSE_INTEGRATION = 'DEFENSE_INTEGRATION',
  DEFENSE_INTEGRATION_CREATE = 'DEFENSE_INTEGRATION_CREATE',
  DEFENSE_INTEGRATION_READ = 'DEFENSE_INTEGRATION_READ',
  DEFENSE_INTEGRATION_UPDATE = 'DEFENSE_INTEGRATION_UPDATE',
  DEFENSE_INTEGRATION_DELETE = 'DEFENSE_INTEGRATION_DELETE',

  // Moni permissions
  MONI_INTEGRATION = 'MONI_INTEGRATION',
  MONI_INTEGRATION_CREATE = 'MONI_INTEGRATION_CREATE',
  MONI_INTEGRATION_READ = 'MONI_INTEGRATION_READ',
  MONI_INTEGRATION_UPDATE = 'MONI_INTEGRATION_UPDATE',
  MONI_INTEGRATION_DELETE = 'MONI_INTEGRATION_DELETE',
  MONI_INTEGRATION_SEND_EVENT = 'MONI_INTEGRATION_SEND_EVENT',

  // Sigma permissions
  SIGMA_INTEGRATION = 'SIGMA_INTEGRATION',
  SIGMA_INTEGRATION_CREATE = 'SIGMA_INTEGRATION_CREATE',
  SIGMA_INTEGRATION_READ = 'SIGMA_INTEGRATION_READ',
  SIGMA_INTEGRATION_UPDATE = 'SIGMA_INTEGRATION_UPDATE',
  SIGMA_INTEGRATION_DELETE = 'SIGMA_INTEGRATION_DELETE',

  // Surgard Client permissions
  SURGARD_CLIENT_INTEGRATION = 'SURGARD_CLIENT_INTEGRATION',
  SURGARD_CLIENT_INTEGRATION_CREATE = 'SURGARD_CLIENT_INTEGRATION_CREATE',
  SURGARD_CLIENT_INTEGRATION_READ = 'SURGARD_CLIENT_INTEGRATION_READ',
  SURGARD_CLIENT_INTEGRATION_UPDATE = 'SURGARD_CLIENT_INTEGRATION_UPDATE',
  SURGARD_CLIENT_INTEGRATION_DELETE = 'SURGARD_CLIENT_INTEGRATION_DELETE',

  // Surgard Server permissions
  SURGARD_SERVER_INTEGRATION = 'SURGARD_SERVER_INTEGRATION',
  SURGARD_SERVER_INTEGRATION_CREATE = 'SURGARD_SERVER_INTEGRATION_CREATE',
  SURGARD_SERVER_INTEGRATION_READ = 'SURGARD_SERVER_INTEGRATION_READ',
  SURGARD_SERVER_INTEGRATION_UPDATE = 'SURGARD_SERVER_INTEGRATION_UPDATE',
  SURGARD_SERVER_INTEGRATION_DELETE = 'SURGARD_SERVER_INTEGRATION_DELETE',

  // Surgard permissions
  SURGARD_INTEGRATION = 'SURGARD_INTEGRATION',
  SURGARD_INTEGRATION_CREATE = 'SURGARD_INTEGRATION_CREATE',
  SURGARD_INTEGRATION_READ = 'SURGARD_INTEGRATION_READ',
  SURGARD_INTEGRATION_UPDATE = 'SURGARD_INTEGRATION_UPDATE',
  SURGARD_INTEGRATION_DELETE = 'SURGARD_INTEGRATION_DELETE',
  SURGARD_INTEGRATION_SEND_EVENT = 'SURGARD_INTEGRATION_SEND_EVENT',

  // Tuya permissions
  TUYA_INTEGRATION = 'TUYA_INTEGRATION',
  TUYA_INTEGRATION_CREATE = 'TUYA_INTEGRATION_CREATE',
  TUYA_INTEGRATION_READ = 'TUYA_INTEGRATION_READ',
  TUYA_INTEGRATION_UPDATE = 'TUYA_INTEGRATION_UPDATE',
  TUYA_INTEGRATION_DELETE = 'TUYA_INTEGRATION_DELETE',

  // Webhook permissions
  WEBHOOK_INTEGRATION = 'WEBHOOK_INTEGRATION',
  WEBHOOK_INTEGRATION_CREATE = 'WEBHOOK_INTEGRATION_CREATE',
  WEBHOOK_INTEGRATION_READ = 'WEBHOOK_INTEGRATION_READ',
  WEBHOOK_INTEGRATION_UPDATE = 'WEBHOOK_INTEGRATION_UPDATE',
  WEBHOOK_INTEGRATION_DELETE = 'WEBHOOK_INTEGRATION_DELETE',
  WEBHOOK_INTEGRATION_PAYLOAD_CREATE = 'WEBHOOK_INTEGRATION_PAYLOAD_CREATE',
  WEBHOOK_INTEGRATION_PAYLOAD_READ = 'WEBHOOK_INTEGRATION_PAYLOAD_READ',
  WEBHOOK_INTEGRATION_PAYLOAD_UPDATE = 'WEBHOOK_INTEGRATION_PAYLOAD_UPDATE',
  WEBHOOK_INTEGRATION_PAYLOAD_DELETE = 'WEBHOOK_INTEGRATION_PAYLOAD_DELETE',

  // Telegram ids permissions
  TELEGRAM_IDS = 'TELEGRAM_IDS',
  TELEGRAM_IDS_CREATE = 'TELEGRAM_IDS_CREATE',
  TELEGRAM_IDS_READ = 'TELEGRAM_IDS_READ',
  TELEGRAM_IDS_UPDATE = 'TELEGRAM_IDS_UPDATE',
  TELEGRAM_IDS_DELETE = 'TELEGRAM_IDS_DELETE',

  // WhatsApp numbers permissions
  WHATSAPP_NUMBERS = 'WHATSAPP_NUMBERS',
  WHATSAPP_NUMBERS_CREATE = 'WHATSAPP_NUMBERS_CREATE',
  WHATSAPP_NUMBERS_READ = 'WHATSAPP_NUMBERS_READ',
  WHATSAPP_NUMBERS_UPDATE = 'WHATSAPP_NUMBERS_UPDATE',
  WHATSAPP_NUMBERS_DELETE = 'WHATSAPP_NUMBERS_DELETE',

  // Sport unities permissions
  SPORT_UNITIES = 'SPORT_UNITIES',
  SPORT_UNITIES_CREATE = 'SPORT_UNITIES_CREATE',
  SPORT_UNITIES_READ = 'SPORT_UNITIES_READ',
  SPORT_UNITIES_UPDATE = 'SPORT_UNITIES_UPDATE',
  SPORT_UNITIES_DELETE = 'SPORT_UNITIES_DELETE',

  // Sport halls permissions
  SPORT_HALLS = 'SPORT_HALLS',
  SPORT_HALLS_CREATE = 'SPORT_HALLS_CREATE',
  SPORT_HALLS_UPDATE = 'SPORT_HALLS_UPDATE',
  SPORT_HALLS_READ = 'SPORT_HALLS_READ',
  SPORT_HALLS_DELETE = 'SPORT_HALLS_DELETE',

  // Recognitions permissions
  RECOGNITION = 'RECOGNITION',
  RECOGNITION_READ = 'RECOGNITION_READ',
  RECOGNITION_DELETE = 'RECOGNITION_DELETE',

  // Recognitions groups permissions
  RECOGNITION_GROUP = 'RECOGNITION_GROUP',
  RECOGNITION_GROUP_CREATE = 'RECOGNITION_GROUP_CREATE',
  RECOGNITION_GROUP_READ = 'RECOGNITION_GROUP_READ',
  RECOGNITION_GROUP_UPDATE = 'RECOGNITION_GROUP_UPDATE',
  RECOGNITION_GROUP_DELETE = 'RECOGNITION_GROUP_DELETE',

  // General recognitions permissions
  GENERAL_RECOGNITION = 'GENERAL_RECOGNITION',
  GENERAL_RECOGNITION_CREATE = 'GENERAL_RECOGNITION_CREATE',
  GENERAL_RECOGNITION_READ = 'GENERAL_RECOGNITION_READ',
  GENERAL_RECOGNITION_UPDATE = 'GENERAL_RECOGNITION_UPDATE',
  GENERAL_RECOGNITION_DELETE = 'GENERAL_RECOGNITION_DELETE',

  // Customer recognitions permissions
  CUSTOMER_RECOGNITION = 'CUSTOMER_RECOGNITION',
  CUSTOMER_RECOGNITION_CREATE = 'CUSTOMER_RECOGNITION_CREATE',
  CUSTOMER_RECOGNITION_READ = 'CUSTOMER_RECOGNITION_READ',
  CUSTOMER_RECOGNITION_UPDATE = 'CUSTOMER_RECOGNITION_UPDATE',
  CUSTOMER_RECOGNITION_DELETE = 'CUSTOMER_RECOGNITION_DELETE',

  // Role config permissions
  CONFIG = 'CONFIG',

  // Customer recognitions events permissions
  CUSTOMER_RECOGNITION_EVENT = 'CUSTOMER_RECOGNITION_EVENT',
  CUSTOMER_RECOGNITION_EVENT_READ = 'CUSTOMER_RECOGNITION_EVENT_READ',

  DVR_DEVICE = 'DVR_DEVICE',
  DVR_DEVICE_CREATE = 'DVR_DEVICE_CREATE',
  DVR_DEVICE_READ = 'DVR_DEVICE_READ',
  DVR_DEVICE_UPDATE = 'DVR_DEVICE_UPDATE',
  DVR_DEVICE_DELETE = 'DVR_DEVICE_DELETE',

  // Student recognitions permissions
  STUDENT_RECOGNITION = 'STUDENT_RECOGNITION',
  STUDENT_RECOGNITION_CREATE = 'STUDENT_RECOGNITION_CREATE',
  STUDENT_RECOGNITION_READ = 'STUDENT_RECOGNITION_READ',
  STUDENT_RECOGNITION_UPDATE = 'STUDENT_RECOGNITION_UPDATE',
  STUDENT_RECOGNITION_DELETE = 'STUDENT_RECOGNITION_DELETE',

  // Responsible recognitions permissions
  RESPONSIBLE_RECOGNITION = 'RESPONSIBLE_RECOGNITION',
  RESPONSIBLE_RECOGNITION_CREATE = 'RESPONSIBLE_RECOGNITION_CREATE',
  RESPONSIBLE_RECOGNITION_READ = 'RESPONSIBLE_RECOGNITION_READ',
  RESPONSIBLE_RECOGNITION_UPDATE = 'RESPONSIBLE_RECOGNITION_UPDATE',
  RESPONSIBLE_RECOGNITION_DELETE = 'RESPONSIBLE_RECOGNITION_DELETE',

  // Distributor
  DISTRIBUTION = 'DISTRIBUTION',

  // Resale
  RESALE = 'RESALE',
  DASHBOARD = 'DASHBOARD',
  SCHOOL_MONITORING_EVENT = 'SCHOOL_MONITORING_EVENT',
  FACE_REGISTER = 'FACE_REGISTER',
  COMMUNICATION = 'COMMUNICATION',
  SIP_CLIENT = 'SIP_CLIENT',

  // School Board permissions
  SCHOOL_BOARD = 'SCHOOL_BOARD',
  SCHOOL_BOARD_CREATE = 'SCHOOL_BOARD_CREATE',
  SCHOOL_BOARD_READ = 'SCHOOL_BOARD_READ',
  SCHOOL_BOARD_UPDATE = 'SCHOOL_BOARD_UPDATE',
  SCHOOL_BOARD_DELETE = 'SCHOOL_BOARD_DELETE',

  // Location permissions
  LOCATION = 'LOCATION',
  LOCATION_CREATE = 'LOCATION_CREATE',
  LOCATION_READ = 'LOCATION_READ',
  LOCATION_UPDATE = 'LOCATION_UPDATE',
  LOCATION_DELETE = 'LOCATION_DELETE',

  // License permissions
  LICENSE = 'LICENSE',
  LICENSE_CREATE = 'LICENSE_CREATE',
  LICENSE_READ = 'LICENSE_READ',
  LICENSE_UPDATE = 'LICENSE_UPDATE',
  LICENSE_DELETE = 'LICENSE_DELETE',
}
